import Seo from "@/components/Seo";
import { Reveal, Eyebrow } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "What we collect",
    body: "Information may include your name, email address, phone number, billing and shipping address, order details, device and usage information, and information you provide when contacting us.",
  },
  {
    title: "Payments",
    body: "Checkout and payment processing are handled securely by Shopify and its payment providers. Full payment card details are not stored by Weird O'Clock.",
  },
  {
    title: "How we use it",
    body: "We use personal information to process and fulfil orders, communicate with you, provide customer support, prevent fraud, improve our services and meet legal obligations.",
  },
  {
    title: "Who we share it with",
    body: "We may share information with Shopify, Syncee, our product suppliers, fulfilment providers, delivery carriers and other service providers where necessary to operate the store and complete your order. We do not sell your personal information.",
  },
  {
    title: "International processing",
    body: "Because we sell internationally and use third party service providers, personal information may be processed or stored in countries other than your own, subject to applicable law.",
  },
  {
    title: "Cookies",
    body: "Our website and Shopify may use functional, analytics and other cookies or similar technologies to operate the store, remember preferences, improve performance, prevent fraud and support checkout.",
  },
  {
    title: "Your rights",
    body: "Depending on where you live, you may have rights to request access to, correction of, or deletion of personal information we hold about you. We handle personal information in accordance with applicable Australian privacy law and other applicable privacy laws.",
  },
  {
    title: "Questions",
    body: "For privacy questions or requests, contact us through the Contact page.",
  },
];

export default function PrivacyPage() {
  return (
    <main data-testid="privacy-page" className="min-h-screen bg-void pt-28 sm:pt-32">
      <Seo
        title="Privacy Policy — Weird O'Clock"
        siteName="Weird O'Clock"
        description="How Weird O'Clock collects, uses and protects your personal information, in line with applicable Australian privacy law."
      />
      <div className="mx-auto max-w-[900px] px-5 pb-24 sm:px-8">
        <Reveal>
          <Eyebrow>Your secrets are safe</Eyebrow>
          <h1 className="font-display text-4xl font-black tracking-tight text-ivory sm:text-5xl lg:text-6xl">
            Privacy <span className="font-editorial italic text-amber">policy</span>
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-ivory/60">
            Weird O'Clock respects your privacy. We collect and process
            personal information that is reasonably necessary to operate our
            store, respond to enquiries, process orders, provide customer
            support, prevent fraud and improve our services.
          </p>
        </Reveal>
        <div className="mt-12">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.04}>
              <div data-testid={`privacy-section-${i}`} className="border-t border-white/10 py-8">
                <h2 className="font-display text-lg font-bold text-ivory sm:text-xl">{s.title}</h2>
                <p className="mt-3 max-w-2xl text-sm leading-relaxed text-ivory/50 sm:text-base">{s.body}</p>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-white/10" />
        </div>
      </div>
    </main>
  );
}
